import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput.tsx';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput.tsx';
import { WidgetConfigurationSlotRender } from '../../common/config-slots/WidgetConfigurationSlotRender.tsx';
import { WidgetConfigurationSlots } from '../../common/config-slots/WidgetConfigurationSlots.tsx';
import { useLabelMenuPreset } from './label-layout/useLabelMenuPreset.ts';
import { type IWidgetParsedProps } from './util/getWidgetProps.ts';
import { WidgetCodeInfoPopover } from './WidgetCodeInfoPopover.tsx';

/** Popover ⓘ del campo "Codice". */
const widgetCodePopover = {
  title: 'Codice del campo',
  content: <WidgetCodeInfoPopover />,
};

export interface ICodeLabelInputFormProps {
  /** Usato solo dal "Numero colonne": richiesto quando il colSpan è visibile. */
  widgetOptions?: IWidgetParsedProps;
  /** Nasconde l'Etichetta (es. widget con etichette proprie, come Province). */
  hideLabel?: boolean;
  /** Non registra il "Numero colonne" (es. widget senza colSpan, come Tabella). */
  hideColSpan?: boolean;
}

/**
 * Blocco Codice + Etichetta (con il fill "Numero colonne" nella card Aspetto
 * e Layout), unica fonte per tutti i form di configurazione widget: usato da
 * CommonConfigComponent e direttamente dai widget che compongono da sé i
 * campi di General (Boolean, Switch, Computed*).
 */
export function CodeLabelInputForm(props: ICodeLabelInputFormProps) {
  const labelMenus = useLabelMenuPreset();
  return (
    <>
      <FormItem
        name="code"
        label="Codice"
        popover={widgetCodePopover}
        help="Identificativo tecnico univoco del campo."
      >
        <TextInput name="code" />
      </FormItem>

      {!props.hideColSpan && (
        <WidgetConfigurationSlotRender
          slot={WidgetConfigurationSlots.Layout}
          order={10}
        >
          <BaseLayoutColSpanInput
            isTableColumn={props.widgetOptions?.isTableColumn ?? false}
          />
        </WidgetConfigurationSlotRender>
      )}

      {!props.hideLabel && (
        <FormItem
          name="label"
          label="Etichetta"
          help={
            <>
              L&apos;<b>Etichetta</b> identifica il campo per chi compila e
              viene letta dagli screen reader: deve descrivere chiaramente il
              dato richiesto.
            </>
          }
        >
          <RichTextAdvancedInput name="label" rows={2} menus={labelMenus} />
        </FormItem>
      )}
    </>
  );
}
